import { fromJS } from 'immutable';
import { createAction, handleActions } from 'redux-actions';

const SET_LOCALE = 'modules/translations/SET_LOCALE';

let defaultLocale = 'en';
const { hostname } = window.location;

if (hostname.includes('awacn') || hostname.includes('affiliateworldasia.cn')) {
  defaultLocale = 'zh';
}

const initialState = fromJS({
  locale: defaultLocale,
});

const reducer = handleActions({
  [SET_LOCALE]: (state, action) => {
    return state.set('locale', action.payload.locale);
  },
}, initialState);

export const setLocale = createAction(SET_LOCALE, (locale) => ({ locale }));

export default reducer;



// WEBPACK FOOTER //
// ./src/modules/translations.js